import { getMatchMenu, type MenuDataItem } from '@umijs/route-utils';
import { RouteContext, type RouteContextType } from './context/RouteContext';
import { getMenuData, type Route } from './getMenuData';
import Logo from './Logo';
import PageLoading from './PageLoading';
import PageTitle from './PageTitle';
import PageWrapper from './PageWrapper';
import RightContent from './RightContent';
import SmartLayout, { type SmartLayoutProps } from './SmartLayout';

export {
  getMatchMenu,
  getMenuData,
  Logo,
  PageLoading,
  PageTitle,
  PageWrapper,
  Route,
  RouteContext,
  RightContent,
  SmartLayout,
  type MenuDataItem,
  type RouteContextType,
  type SmartLayoutProps,
};
